import React, { useContext } from 'react'
import Image from 'next/image'
import { CompanionBusinessCardElement } from './styles'
import { buildCompanyUrl } from '../../../../helpers/urlBuilder'
import { slugify } from '../../../../helpers/slugify'
import AppContext from '../../../../context/AppContext'
import { ELanguage } from '@microfrontends/react-components'
import { EDevice } from '../../../../containers/MainLayout'
const DEFAULT_COMPANY_LOGO =
	process.env.IMAGE_BASE_URL + '/img/company-default-logo.svg'

interface IProps {
	numsOfItem: number
	data: {
		companyName: string
		companyLogo: string
		companyId?: number
		description: string
		companyUrl?: string
	}
}

const CompanionBusinessCard: React.FC<IProps> = ({ data, numsOfItem }) => {
	const { breakpoint } = useContext(AppContext)
	const {
		Container,
		CompanyName,
		Tooltip,
		TooltipContainer,
		TooltipContent
	} = CompanionBusinessCardElement
	const { languageCode } = useContext(AppContext)
	return (
		<Tooltip
			placement='top'
			disabled={breakpoint === EDevice.MOBILE}
			content={
				<TooltipContainer>
					<TooltipContent>{data.description}</TooltipContent>
				</TooltipContainer>
			}
			numsOfItem={numsOfItem}
			referenceElement={
				<Container href={data.companyUrl} title={data.companyName}>
					<Image
						width={70}
						height={70}
						src={data.companyLogo || DEFAULT_COMPANY_LOGO}
						alt={data.companyName}
						objectFit='contain'
					/>
					<CompanyName>{data.companyName}</CompanyName>
				</Container>
			}
		/>
	)
}

export default CompanionBusinessCard
